<template>
  <!-- Report Scan Recommendation Configuration -->
  <div class="row mt-2">
    <div class="col-5">
      <div class="input-group">
        <span class="input-group-text">Title:</span>
        <input
          v-show="isEditRecommendation || isAddRecommendation"
          v-model="title"
          type="text"
          class="form-control"
          placeholder="new recommendation"
        />
        <select
          v-show="!isEditRecommendation && !isAddRecommendation"
          v-model="selectedItem"
          class="form-control custom-select"
          @change="selectedRecommendation"
        >
          <option v-for="item of recommendations" :key="item.reportRecommendation" :value="item.reportRecommendation">{{ item.title }}</option>
        </select>
        <button
          v-if="isSelectedRecommendation && !isEditRecommendation && !isAddRecommendation"
          class="btn btn-warning custom-focus"
          type="button"
          title="edit title"
          tabindex="-1"
          @click="editRecommendation"
        >
          <i class="far fa-edit"></i>
        </button>
        <button
          v-if="isSelectedRecommendation && !isEditRecommendation && !isAddRecommendation"
          class="btn btn-danger custom-focus"
          type="button"
          title="remove recommendation"
          tabindex="-1"
          @click="removeRecommendation"
        >
          <i class="far fa-trash-alt"></i>
        </button>
        <button
          v-if="isSelectedRecommendation || isAddRecommendation"
          class="btn btn-warning custom-focus"
          type="button"
          title="cancel"
          tabindex="-1"
          @click="cancel"
        >
          <i class="fas fa-ban"></i>
        </button>
        <button
          v-if="!isEditRecommendation && !isAddRecommendation"
          class="btn btn-success custom-focus"
          type="button"
          title="add recommendation"
          tabindex="-1"
          @click="addRecommendation"
        >
          <i class="fas fa-plus"></i>
        </button>
      </div>
    </div>
    <div class="col-4">
      <div class="input-group">
        <span class="input-group-text">Year Start</span>
        <select v-model="yearStart" class="form-control">
          <option v-for="item of viewYears" :key="item.id" :value="item.value">{{ item.name }}</option>
        </select>
        <span class="input-group-text">Year End</span>
        <select v-model="yearEnd" class="form-control">
          <option v-for="item of viewYears" :key="item.id" :value="item.value">{{ item.name }}</option>
        </select>
        <button v-if="isSave" class="btn btn-danger custom-focus" type="button" tabindex="-1" @click="save">Save</button>
      </div>
    </div>
  </div>
  <!-- Relate to Systems and Vehicle Makes -->
  <div class="row mt-3">
    <div class="col text-center">
      <span class="custom-list-title">Systems</span>
    </div>
    <div class="col text-center">
      <span class="custom-list-title">Vehicles</span>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="row">
        <div class="col">
          <div class="custom-checkall">
            <input v-model="checkAllSystems" :value="item" type="checkbox" class="custom-checkbox" @click="checkedAllSystems" />
            <span class="ms-2">check all</span>
          </div>
          <ul class="custom-list">
            <li v-for="item of systems" :key="item.id">
              <input v-model="item.selected" :value="item" type="checkbox" class="custom-checkbox" />
              <span class="ms-2">{{ item.name }}</span>
            </li>
          </ul>
        </div>
        <div class="col-1">
          <div class="custom-actions">
            <button class="btn btn-secondary btn-sm custom-focus" type="button" tabindex="-1" @click="move('system-add')">
              <i class="fas fa-chevron-right"></i>
            </button>
            <button class="btn btn-secondary btn-sm custom-focus mt-2" type="button" tabindex="-1" @click="move('system-remove')">
              <i class="fas fa-chevron-left"></i>
            </button>
          </div>
        </div>
        <div class="col">
          <div class="custom-checkall">
            <input v-model="checkAllSelectedSystems" :value="item" type="checkbox" class="custom-checkbox" @click="checkedAllSelectedSystems" />
            <span class="ms-2">check all</span>
          </div>
          <ul class="custom-list">
            <li v-for="item of selectedSystems" :key="item.id">
              <input v-model="item.selected" :value="item" type="checkbox" class="custom-checkbox" @click="isSave = true" />
              <span class="ms-2">{{ item.name }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="row">
        <div class="col">
          <div class="custom-checkall">
            <input v-model="checkAllMakes" :value="item" type="checkbox" class="custom-checkbox" @click="checkedAllMakes" />
            <span class="ms-2">check all</span>
          </div>
          <ul class="custom-list">
            <li v-for="item of vehicles" :key="item.id">
              <input v-model="item.selected" :value="item" type="checkbox" class="custom-checkbox" />
              <span class="ms-2">{{ item.name }}</span>
            </li>
          </ul>
        </div>
        <div class="col-1">
          <div class="custom-actions">
            <button class="btn btn-secondary btn-sm custom-focus" type="button" tabindex="-1" @click="move('make-add')">
              <i class="fas fa-chevron-right"></i>
            </button>
            <button class="btn btn-secondary btn-sm custom-focus mt-2" type="button" tabindex="-1" @click="move('make-remove')">
              <i class="fas fa-chevron-left"></i>
            </button>
          </div>
        </div>
        <div class="col">
          <div class="custom-checkall">
            <input v-model="checkAllSelectedMakes" :value="item" type="checkbox" class="custom-checkbox" @click="checkedAllSelectedMakes" />
            <span class="ms-2">check all</span>
          </div>
          <ul class="custom-list">
            <li v-for="item of selectedMakes" :key="item.id">
              <input v-model="item.selected" :value="item" type="checkbox" class="custom-checkbox" @click="isSave = true" />
              <span class="ms-2">{{ item.name }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col">
      <div class="col custom-editor">
        <editor ref="zEditor" v-model:content="recommendation" content-type="html" @message="showMessage" />
      </div>
    </div>
  </div>
  <div class="row mt-2">
    <div class="col">
      <z-message v-model="message" :timeout="3000" class="alert alert-warning" />
    </div>
  </div>
  <confirm-delete
    v-model="actionDelete"
    :confirm-title="confirmTitle"
    :confirm-action="confirmAction"
    :confirm-question="confirmQuestion"
    @closing="closeModal"
    @proceed="performDelete"
  />
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { adasmatrixStore } from '@/stores/adasmatrix'
import ZMessage from '@/components/utilities/elements/Message.vue'
import Editor from '@/components/utilities/elements/Editor.vue'
import ConfirmDelete from '@/components/utilities/elements/ConfirmDialog.vue'
import _ from 'lodash'
export default {
  name: 'ReportConfig',
  components: {
    ZMessage,
    Editor,
    ConfirmDelete
  },
  data() {
    return {
      vehicles: [],
      systems: [],
      isSave: false,
      isEditRecommendation: false,
      isAddRecommendation: false,
      selectedItem: null,
      isSelectedRecommendation: false,
      checkAllSystems: false,
      checkAllSelectedSystems: false,
      checkAllMakes: false,
      checkAllSelectedMakes: false,
      message: null,
      actionDelete: null,
      confirmTitle: 'Delete this Report Recommendation?',
      confirmAction: 'Delete',
      confirmQuestion: 'Are you sure you wish to Delete this Report Recommendation?',
      isResetting: false
    }
  },
  mounted() {
    this.init()
  },
  computed: {
    ...mapState(adasmatrixStore, ['loading', 'lookups', 'reportRecommendation', 'reportRecommendations']),
    viewYears() {
      let _data = [
        {
          id: 0,
          name: null,
          value: null
        }
      ]
      let cnt = 1
      for (let idx = new Date().getFullYear() + 3; idx >= 2007; idx--) {
        _data.push({
          id: cnt,
          name: idx,
          value: idx
        })
        cnt++
      }
      return _data
    },
    recommendations() {
      let _data = []
      if (this.reportRecommendations) {
        this.reportRecommendations.forEach((element) => {
          _data.push(element)
        })
      }
      return _data
    },
    title: {
      get() {
        return this.reportRecommendation.title
      },
      set(value) {
        this.setRecommendation({
          name: 'title',
          value: value
        })
        this.isSave = true
      }
    },
    yearStart: {
      get() {
        return this.reportRecommendation.yearStart
      },
      set(value) {
        this.setRecommendation({
          name: 'yearStart',
          value: value
        })
        this.isSave = true
      }
    },
    yearEnd: {
      get() {
        return this.reportRecommendation.yearEnd
      },
      set(value) {
        this.setRecommendation({
          name: 'yearEnd',
          value: value
        })
        this.isSave = true
      }
    },
    recommendation: {
      get() {
        return this.reportRecommendation.content
      },
      set(value) {
        if (!this.isResetting) {
          this.setRecommendation({
            name: 'content',
            value: value
          })
          this.isSave = true
        }
      }
    },
    selectedSystems: {
      get() {
        return this.reportRecommendation.systems
      },
      set(value) {
        this.setRecommendation({
          name: 'selectSystem',
          value: value
        })
        this.isSave = true
      }
    },
    selectedMakes: {
      get() {
        return this.reportRecommendation.makes
      },
      set(value) {
        this.setRecommendation({
          name: 'selectMake',
          value: value
        })
        this.isSave = true
      }
    }
  },
  methods: {
    ...mapActions(adasmatrixStore, ['getRecommendations', 'setRecommendation', 'deleteRecommendation', 'saveRecommendation', 'deleteRecommendation']),
    init() {
      let cnt = 0
      this.reset()
      this.systems = []
      this.vehicles = []
      if (this.lookups) {
        if (this.lookups['VehicleMake']) {
          let temp = JSON.parse(JSON.stringify(this.lookups['VehicleMake']))
          this.vehicles = _.sortBy(temp, ['name'])
          this.vehicles.forEach((element) => {
            element.selected = false
          })
        }
        if (this.lookups['SystemType']) {
          let temp = JSON.parse(JSON.stringify(this.lookups['SystemType']))
          this.systems = _.sortBy(temp, ['name'])
          this.systems.forEach((element) => {
            element.id = cnt
            element.selected = false
            cnt++
          })
        }
      }
    },
    closeModal() {
      this.actionDelete = null
    },
    reset() {
      this.message = null
      this.isEditRecommendation = false
      this.isAddRecommendation = false
      this.selected = null
      this.isSelectedRecommendation = false
      this.checkAllSystems = false
      this.checkAllSelectedSystems = false
      this.checkAllMakes = false
      this.checkAllSelectedMakes = false
      this.isSave = false
      this.isResetting = true
      setTimeout(() => {
        this.$refs.zEditor.setHTML('')
        this.isSave = false
        this.isResetting = false
      }, 100)
      this.isSave = false
    },
    showMessage(msg) {
      this.message = msg
    },
    addRecommendation() {
      console.log('Add Recommendation')
      this.reset()
      this.selectedItem = null
      this.setRecommendation({
        name: 'recommendation',
        value: null
      })
      this.isAddRecommendation = true
    },
    selectedRecommendation() {
      this.reset()
      this.isSelectedRecommendation = true
      setTimeout(() => {
        console.log('Selected Recommendation', this.selectedItem)
        this.isSave = false
        this.setRecommendation({
          name: 'selected',
          value: this.selectedItem
        })
        this.isSave = false
      }, 250)
    },
    editRecommendation() {
      console.log('Edit Recommendation', this.selectedItem)
      this.isEditRecommendation = true
    },
    async removeRecommendation() {
      this.actionDelete = this.reportRecommendation
    },
    async performDelete() {
      console.log('Remove Report Recommendation', this.reportRecommendation.reportRecommendation)
      await this.deleteRecommendation(this.reportRecommendation.reportRecommendation)
      this.selectedItem = null
      this.setRecommendation({
        name: 'recommendation',
        value: null
      })
      this.reset()
      this.actionDelete = null
      this.getRecommendations()
    },
    cancel() {
      console.log('cancel')
      this.selectedItem = null
      this.setRecommendation({
        name: 'recommendation',
        value: null
      })
      this.reset()
      setTimeout(() => {
        this.isSave = false
      }, 100)
      this.isSave = false
    },
    checkedAllSystems() {
      setTimeout(() => {
        this.checkAllSelectedSystems = false
        this.setRecommendation({
          name: 'chkAllSelectedSystems',
          value: false
        })
        this.systems.forEach((element) => {
          element.selected = this.checkAllSystems
        })
      }, 250)
    },
    checkedAllSelectedSystems() {
      setTimeout(() => {
        this.checkAllSystems = false
        this.systems.forEach((element) => {
          element.selected = false
        })
        this.setRecommendation({
          name: 'chkAllSelectedSystems',
          value: this.checkAllSelectedSystems
        })
      }, 250)
    },
    checkedAllMakes() {
      setTimeout(() => {
        this.checkAllSelectedMakes = false
        this.setRecommendation({
          name: 'chkAllSelectedMakes',
          value: false
        })
        this.vehicles.forEach((element) => {
          element.selected = this.checkAllMakes
        })
      }, 250)
    },
    checkedAllSelectedMakes() {
      setTimeout(() => {
        this.checkAllMakes = false
        this.vehicles.forEach((element) => {
          element.selected = false
        })
        this.setRecommendation({
          name: 'chkAllSelectedMakes',
          value: this.checkAllSelectedMakes
        })
      }, 250)
    },
    move(dir) {
      console.log('move', dir)
      this.isSave = true
      if (dir.substring(0, 6) === 'system') {
        if (dir.substring(7) === 'add') {
          this.systems.forEach((element) => {
            if (element.selected) {
              let temp = {
                id: parseInt(element.value),
                name: element.name,
                selected: false
              }
              let found = this.selectedSystems.find((item) => {
                return item.id === temp.id
              })
              if (!found) {
                this.setRecommendation({
                  name: 'addSystem',
                  value: temp
                })
              }
            }
          })
        } else {
          this.setRecommendation({
            name: 'removeSystems',
            value: null
          })
        }
        this.checkAllSystems = false
        this.systems.forEach((element) => {
          element.selected = false
        })
        this.checkAllSelectedSystems = false
      } else {
        if (dir.substring(5) === 'add') {
          this.vehicles.forEach((element) => {
            if (element.selected) {
              let temp = {
                id: parseInt(element.value),
                name: element.name,
                selected: false
              }
              let found = this.selectedMakes.find((item) => {
                return item.id === temp.id
              })
              if (!found) {
                this.setRecommendation({
                  name: 'addMake',
                  value: temp
                })
              }
            }
          })
        } else {
          this.setRecommendation({
            name: 'removeMakes',
            value: null
          })
        }
        this.checkAllMakes = false
        this.vehicles.forEach((element) => {
          element.selected = false
        })
        this.checkAllSelectedMakes = false
      }
    },
    validate() {
      let valid = true
      console.log('Validate', this.reportRecommendation)
      if (!this.title) {
        this.showMessage('Title is required')
        valid = false
      }
      if (valid && !this.yearStart) {
        this.showMessage('Year Start is required')
        valid = false
      }
      if (valid && !this.yearEnd) {
        this.showMessage('Year End is required')
        valid = false
      }
      if (valid && !this.recommendation) {
        this.showMessage('Recommendation is required')
        valid = false
      }
      if (valid && this.selectedSystems.length === 0) {
        this.showMessage('Systems are required')
        valid = false
      }
      if (valid && this.selectedMakes.length === 0) {
        this.showMessage('Vehicles are required')
        valid = false
      }
      return valid
    },
    async save() {
      this.setRecommendation({
        name: 'systems',
        value: this.selectedSystems
      })
      this.setRecommendation({
        name: 'makes',
        value: this.selectedMakes
      })
      if (this.validate()) {
        console.log('Save Report Recommendation', this.reportRecommendation)
        let id = await this.saveRecommendation()
        this.setRecommendation({
          name: 'id',
          value: id
        })
        this.selectedItem = this.reportRecommendation.reportRecommendation
        await this.getRecommendations()
        this.selectedRecommendation()
        this.isSave = false
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-list-title {
  font-weight: 600;
  font-size: 1.1rem;
}
.custom-checkall {
  margin-left: 10px;
  margin-bottom: 5px;
  height: 22px;
}
.custom-list {
  border-top: 1px solid #ced4da;
  list-style-type: none;
  padding: 0;
  padding-top: 5px;
  padding-left: 10px;
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 280px;
}
.custom-actions {
  margin-top: 50px;
  text-align: center;
}
.custom-editor {
  height: 220px;
}
</style>
